import { SelectableLink, SelectableLinkContainer } from "components/Link";
import Range from "components/Range";
import Title from "components/Title";
import { doorCloses } from "core/constants/sound";
import { getRandomItem } from "core/utils/logic";
import { processText } from "core/utils/string";
import { toggleFullScreen } from "core/utils/window";
import React from "react";
import { GiSoundOff, GiSoundOn, GiSpeaker, GiSpeakerOff } from "react-icons/gi";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEscapeGoesBack } from "hooks/navigation";
import { usePlaySoundEffect } from "hooks/sound";
import {
  getOption,
  MUSIC_MUTED,
  MUSIC_VOLUME,
  setOption,
  SOUND_EFFECTS_MUTED,
  SOUND_EFFECTS_VOLUME,
  toggleOption,
} from "reducer/options";
import styled from "styled-components";
import { desktop } from "submodules/sharedText/flavor";

const { general, settings } = desktop;
const flavor = { ...general, ...settings };

const Wrapper = styled.div`
  margin-top: 3vh;
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
`;

const IconStyles = `
  margin-left: 1vh;
  font-size: 7vh;
`;

const MusicOff = styled(GiSoundOff)`
  ${IconStyles}
`;
const MusicOn = styled(GiSoundOn)`
  ${IconStyles}
`;

const SoundOn = styled(GiSpeaker)`
  ${IconStyles}
`;
const SoundOff = styled(GiSpeakerOff)`
  ${IconStyles}
`;

const Settings = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const escapeGoesBack = useEscapeGoesBack();

  const musicMuted = useSelector(getOption(MUSIC_MUTED));
  const musicVolume = useSelector(getOption(MUSIC_VOLUME));
  const soundEffectsMuted = useSelector(getOption(SOUND_EFFECTS_MUTED));
  const soundEffectsVolume = useSelector(getOption(SOUND_EFFECTS_VOLUME));

  const playSoundEffect = usePlaySoundEffect();
  const homePath = location.pathname.startsWith("/desktop") ? "/desktop" : "/";

  return (
    <>
      <Wrapper>
        <Title white>{processText(flavor.title)}</Title>
        <SelectableLinkContainer handleKeyDown={escapeGoesBack}>
          <SelectableLink
            to={homePath}
            onClick={() => playSoundEffect(getRandomItem(doorCloses))}
            backButton
          />
          <SelectableLink onClick={toggleFullScreen}>
            {processText(flavor.toggleFullScreen)}
          </SelectableLink>
          <SelectableLink onClick={() => dispatch(toggleOption(MUSIC_MUTED))}>
            <>
              {processText(flavor.music)}
              <MusicOn hidden={musicMuted} />
              <MusicOff hidden={!musicMuted} />
            </>
          </SelectableLink>
          <Range
            value={musicVolume}
            onChange={(volume) => dispatch(setOption(MUSIC_VOLUME, volume))}
          />
          <SelectableLink
            onClick={() => dispatch(toggleOption(SOUND_EFFECTS_MUTED))}
          >
            <>
              {processText(flavor.soundEffects)}
              <SoundOn hidden={soundEffectsMuted} />
              <SoundOff hidden={!soundEffectsMuted} />
            </>
          </SelectableLink>
          <Range
            value={soundEffectsVolume}
            onChange={(volume) =>
              dispatch(setOption(SOUND_EFFECTS_VOLUME, volume))
            }
          />
        </SelectableLinkContainer>
      </Wrapper>
    </>
  );
};

export default Settings;
